export class Psy {

	constructor() {
		let url = new URL(window.location.href);
		this.id = url.searchParams.get('project_id');
		this.steps = $('#project_steps').length ? $('#project_steps').val().split(/,/) : [];
	}

	auth(parent) {
		let el = $(parent);
		el.find('button').prop('disabled', true);
		$.ajax({
			url: "/ajax.php?mid=12",
			type: 'POST',
			data: el.serialize() + '&version=v2',
			dataType: "json",
			success: function(res){
				el.find('button').prop('disabled', false);
				
				if (res['success'])
				{
					el.find('.psy-app__step-mistakes').hide();
					location.reload();
				}
				else
				{
					el.find('.psy-app__step-mistakes p').text(res.error);
					if (res.activate_link)
					{
						el.find('.psy-app__step-mistakes p').append('. <a href="' + res.activate_link + '" target="_blank">Выслать код активации повторно</a>');
					}
					el.find('.psy-app__step-mistakes').slideDown();
				}
			},
			error: function(res){
				el.find('button').prop('disabled', false);
				el.find('.psy-app__step-mistakes p').text('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
				el.find('.psy-app__step-mistakes').slideDown();
			}			
		});
	}

	remind(parent) {
		let el = $(parent);
		el.find('button').prop('disabled', true);
		$.ajax({
			url: "/ajax.php?mid=12",
			type: 'POST',
			data: el.serialize() + '&action=forget',
			dataType: "json",
			success: function(res){
				el.find('button').prop('disabled', false);
				
				if (res['success'])
				{
					el.find('.psy-app__item-mistake').hide();
					el.closest('.popup').find('.popup-password__form').hide();
					el.closest('.popup').find('.popup-password__success').fadeIn();
				}
				else
				{
					el.find('.psy-app__item-mistake').text(res.error);
					if (res.activate_link)
					{
						el.find('.psy-app__item-mistake').append('. <a href="' + res.activate_link + '" target="_blank">Выслать код активации повторно</a>');
					}
					el.find('.psy-app__item-mistake').slideDown();
				}
			},
			error: function(res){
				el.find('button').prop('disabled', false);
				el.find('.psy-app__item-mistake').text('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
				el.find('.psy-app__item-mistake').slideDown();
			}			
		});
	}

	preview() {
		let params = `scrollbars=yes,resizable=yes,status=no,location=no,toolbar=no,menubar=no,width=800,height=600,left=100,top=100`;
		window.open(location.pathname + location.search + '&preview=1', 'preview', params);
		this.steps.push(4);
		this.markStep(4, 'done');
	}

	save(block) {
		let _this = this;
		let blockName = block.attr('id');

		$('#htm_desc').html(this.referatEditor.getData());

		let data = block.find('input, select, textarea').serialize();
		for (let i = 0; i < this.steps.length; i++)
		{
			data += '&steps[]=' + this.steps[i];
		}
	
		$.ajax({
			url: "/ajax.php?mid=107",
			type: "POST",
			data: data + '&block=' + blockName + '&action=save&id=' + this.id,
			dataType: "json",
			success: function(res) {
				
				console.log(res);								
			
				if (res.success){
					if (res.addedNew)
					{
						_this.id = res.id;
						let url = new URL(window.location.href);
						history.replaceState(null, '', url.pathname + '?project_id=' + _this.id);
					}
					if (res.steps)
					{
						_this.steps = res.steps;
					}

					if (res['typographed'])
					{
						_this.referatEditor.setData(res['typographed']);
					}

					_this.parseErrors(res);
					block.find('.psy-app__draft-btn').children(".psy-app__draft-saved").fadeIn().delay(1000).fadeOut(200);
					block.find('.psy-app__step-mistakes p').text('');
					block.find('.psy-app__step-mistakes').hide();
				}else{
					block.find('.psy-app__step-mistakes p').text('Возникла ошибка: ' + res.error);
					block.find('.psy-app__step-mistakes').fadeIn();
				}

				_this.control(res.control);

			},
			fail: function(e){

				console.log(e)
			}
		});			
	}

	process(res) {
		this.parseErrors(res);
		this.control(res.control);
	}

	parseErrors(res) {
		if (!res.check) return;

		let step;
		let stepErrors;
		let err;

		$('.psy-app__item-mistake[data-field]').hide().text('');
		for (let i = 0; i < this.steps.length; i++)
		{
			step = this.steps[i];
			stepErrors = 0;
			for (let j = 0; j < res.check.errors.length; j++)
			{
				if (res.check.errors[j].step == step)
				{
					err = res.check.errors[j];
					console.log(err);
					$('.psy-app__item-mistake[data-field="' + err.field + '"]').text(err.text).show();

					stepErrors++;
				}
			}

			if (stepErrors)
			{
				this.markStep(step, 'error');
			}
			else
			{
				this.markStep(step, 'done');
			}
		}

		if (res.check.errors.length)
		{
			$('.psy-app__final button').prop('disabled', true);
			$('.psy-app__final #submit_deny').fadeIn();
			$('.psy-app__final #submit_allow').hide();
		}
		else
		{
			$('.psy-app__final button').prop('disabled', false);
			$('.psy-app__final #submit_allow').fadeIn();
			$('.psy-app__final #submit_deny').hide();
		}
	}

	markStep(step, status) {
		let el = $('.psy-app__nav-list li button').eq(step - 1);
		if (status == 'error')
			el.addClass('attention');
		else
			el.removeClass('attention');

		el.addClass('ready');
	}

	findPerson(parent) {
		let data = $(parent).serialize();

		$.ajax({
			url: "/ajax.php?mid=107",
			type: "POST",
			data: data + '&action=findPerson',
			dataType: "html",
			success: function(html) {
				$('.psy-app__selection-content').html(html);
				$('.psy-app__selection-content').slideDown();
			}
		});
	}

	changeDir(parent) {
		let _this = this;
		let input = $(parent);
		console.log(input);
		if (input.prop('checked'))
		{
			$.ajax({
				url: "/ajax.php?mid=107",
				type: "POST",
				data: {action: 'changeDir', id: this.id, director: input.val()},
				dataType: "json",
				success: function(res) {
					$('#authors-block .authors-added__container').html(res.html);
					_this.process(res);
				}
			});
		}

		
	}

	addMe(parent, type) {
		let _this = this;
		if (type != 'authors' && type != 'coauthors') return;
		$(parent).attr("disabled", true);

		$.ajax({
			url: "/ajax.php?mid=107",
			type: "POST",
			data: {
					action: 'addMe',
					id: this.id,
					type: type
				},
			dataType: "json",
			success: function(res) {
				if (res.success)
				{
					$('#' + type + '-block .authors-added__container').html(res.html);
					if (res.count > 0)
					{
						$('#' + type + '-block').slideDown();
					}
					else
					{
						$('#' + type + '-block').hide();
					}

					if (type == 'authors')
					{
						if (res.count >= 3)
						{
							$('#author_buttons button').prop('disabled', true);
						}
						else
						{
							$('#author_buttons button').prop('disabled', false);
						}
					}
					_this.process(res);
				}
				else
				{

				}
			}
		});		
	}

	addPerson(parent, type, id) {
		let _this = this;
		if (type != 'authors' && type != 'coauthors') return;

		$.ajax({
			url: "/ajax.php?mid=107",
			type: "POST",
			data: {
					action: 'addPerson',
					id: this.id,
					type: type,
					personId: id
				},
			dataType: "json",
			success: function(res) {
				if (res.success)
				{
					$('#' + type + '-block .authors-added__container').html(res.html);
					if (res.count > 0)
					{
						$('#' + type + '-block').slideDown();
					}
					else
					{
						$('#' + type + '-block').hide();
					}

					if (type == 'authors')
					{
						if (res.count >= 3)
						{
							$('#author_buttons button').prop('disabled', true);
						}
						else
						{
							$('#author_buttons button').prop('disabled', false);
						}
					}

					_this.process(res);
				}
				else
				{

				}

				let popup = $(parent).closest('.popup-search-author');
				popup.removeClass('active');
				$('body').removeClass('no-scroll');
			}
		});		
	}

	addLink(parent) {
		let _this = this;

		let type = $(parent).closest('.psy-app__group').attr('id').replace(/block-upload-/, '');
		
		let link;
		let desc;

		if (type == 'links')
		{
			link = $(parent).closest('.psy-app__link').find('.psy-app__link-input').val();
			desc = $(parent).closest('.psy-app__link').find('.psy-app__link-description').val();
		}
		else
		{
			link = $(parent).closest('.psy-app__link').find('input').val();
			desc = null;
		}

		$.ajax({
			url: "/ajax.php?mid=107",
			type: "POST",
			data: {
					action: 'addLink',
					id: this.id,
					type: type,
					link: link,
					desc: desc
				},
			dataType: "json",
			success: function(res) {
				if (res.success)
				{
					let block = $('#block-upload-' + type + ' .psy-app__upload-results');
					block.html(res.html);
					if (res.count > 0)
					{
						block.slideDown();
					}
					else
					{
						block.hide();
					}
					_this.hideError(parent);
					_this.process(res);

					$(parent).closest('.psy-app__link').find('input').val('');
				}
				else
				{
					_this.showError(parent, 'Ошибка ' + res.error);
				}
			}
		});	
	}

	captureFiles(parent) {
		let files = parent.files;
		let type = $(parent).closest('.psy-app__group').attr('id').replace(/block-upload-/, '');

		for (let i = 0; i < files.length; i++)
		{
			let file = files[i];
			this.uploadFile(parent, type, file)
		}
	}

	uploadFile(parent, type, file) {
		// TODO save filenames
		$(document.activeElement).blur().trigger('focusout');
		psy.save($(this).closest('.psy-app__step'));
		if (file.size > 524288000)
		{
			this.showError(parent, 'Размер файла ' + file.name);
			return ;
		}

		let _this = this;
		let reader = new FileReader();
		let url = '/ajax.php?mid=107&action=uploadFile&type=' + type + '&id=' + this.id;

		reader.onload = function() {    
			let xhr = new XMLHttpRequest();    

			xhr.upload.addEventListener("progress", function(e) {
				if (e.lengthComputable) {
					let progress = (e.loaded * 100) / e.total;
					// показать прогресс
				}
			}, false);

			xhr.onreadystatechange = function () {
				if (this.readyState == 4) 
				{
					if(this.status == 200) 
					{
						let res = $.parseJSON(this.responseText);
						if (res.success)
						{
							let block = $('#block-upload-' + type + ' .psy-app__upload-results');
							block.html(res.html);
							if (res.count > 0)
							{
								block.slideDown();
								// DONE put curson in li.upload-results__item:last-child and highlight its text
								let lastItem = block.find('li.upload-results__item:last-child > div > input:nth-child(1)');
								lastItem.focus();
								lastItem.select();
								// save on filename focus change
								lastItem.focusout(function(){
									// console.log("focus event")
									psy.save($(this).closest('.psy-app__step'));
								});
							}
							else
							{
								block.hide();
							}
							_this.hideError(parent);
							_this.process(res);
							$(parent).val('');
						}
						else
						{
							if (res.errorType == 'count')
							{
								$('.popup-mistake').addClass('active');
								$('body').addClass('no-scroll');
							}
							_this.showError(parent, 'Ошибка ' + res.error);
							$(parent).val('');
						}
					}
					else 
					{
						_this.showError(parent, 'Ошибка ' + this.error);
						$(parent).val('');
					}
				}
			};

			xhr.open("POST", url);

			var formData = new FormData();
			formData.append('myFile', file);
			xhr.send(formData);
		};

		reader.readAsBinaryString(file);	
	}

	loadPhoto(parent)
	{
		if (!parent.files.length)
			return;
		
		let file = parent.files[0];
		let reader = new FileReader();
		let url = '/ajax.php?mid=107&action=loadPhoto&id=' + this.id;

		reader.onload = function() {    
			let xhr = new XMLHttpRequest();    

			xhr.upload.addEventListener("progress", function(e) {
				if (e.lengthComputable) {
					let progress = (e.loaded * 100) / e.total;
					// показать прогресс
				}
			}, false);

			xhr.onreadystatechange = function () {
				if (this.readyState == 4) 
				{
					if(this.status == 200) 
					{
						let res = $.parseJSON(this.responseText);
						if (res.success)
						{
							let el = $(parent).closest('.author-new__photo');
							el.find('input[type=hidden]').val(res.filename);
							el.find('.author-new__photo-image').attr('src', res.filename);
							el.find('.author-new__photo-upload').hide();
							el.find('.author-new__photo-delete').show();
						}
						else
						{
							// вывести ошибку
						}
					}
					else 
					{
						// вывести ошибку
					}
				}
			};

			xhr.open("POST", url);

			var formData = new FormData();
			formData.append('myFile', file);
			xhr.send(formData);
		};

		reader.readAsBinaryString(file);
	}

	delPhoto(parent) {
		let el = $(parent).closest('.author-new__photo');
		el.find('input[type=hidden]').val('');
		el.find('input[type=file]').val('');
		el.find('.author-new__photo-image').attr('src', '/psy_app/media/image_photo.svg');
		el.find('.author-new__photo-upload').show();
		el.find('.author-new__photo-delete').hide();
	}

	delFile(parent, type, id) {
		let _this = this;

		if (type != 'referat' && type != 'materials' && type != 'recomends' && type != 'closed' && type != 'links' && type != 'img') return;
		
		$(parent).closest('.upload-results__item').fadeOut();

		$.ajax({
			url: "/ajax.php?mid=107",
			type: "POST",
			data: {
					action: 'delFile',
					id: this.id,
					type: type,
					fileId: id
				},
			dataType: "json",
			success: function(res) {
				if (res.success)
				{
					_this.hideError(parent, 1);
					let block = $('#block-upload-' + type + ' .psy-app__upload-results');
					block.html(res.html);
					if (res.count > 0)
					{
						block.slideDown();
					}
					else
					{
						block.hide();
					}
					_this.process(res);
				}
				else
				{

				}

				// save on filename focus change
				$('.psy-app__input_autosave').focusout(function(){
					// console.log("focus event")
					psy.save($(this).closest('.psy-app__step'));
				});
			}
		});		
	}

	delLink(parent, type, id) {
		let _this = this;

		if (type != 'referat' && type != 'materials' && type != 'recomends' && type != 'closed' && type != 'links') return;
		
		$(parent).closest('.upload-results__item').fadeOut();

		$.ajax({
			url: "/ajax.php?mid=107",
			type: "POST",
			data: {
					action: 'delLink',
					id: this.id,
					type: type,
					fileId: id
				},
			dataType: "json",
			success: function(res) {
				if (res.success)
				{
					_this.hideError(parent, 1);
					let block = $('#block-upload-' + type + ' .psy-app__upload-results');
					block.html(res.html);
					if (res.count > 0)
					{
						block.slideDown();
					}
					else
					{
						block.hide();
					}
					_this.process(res);
				}
				else
				{

				}

			}
		});		
	}

	removePerson(parent, type, id) {
		let _this = this;
		if (type != 'authors' && type != 'coauthors') return;
		
		$(parent).closest('.authors-added__item').fadeOut();

		$.ajax({
			url: "/ajax.php?mid=107",
			type: "POST",
			data: {
					action: 'removePerson',
					id: this.id,
					type: type,
					personId: id
				},
			dataType: "json",
			success: function(res) {
				if (res.success)
				{
					$('#' + type + '-block .authors-added__container').html(res.html);
					if (res.count > 0)
					{
						$('#' + type + '-block').slideDown();
					}
					else
					{
						$('#' + type + '-block').hide();
					}

					if (type == 'authors')
					{
						if (res.count >= 3)
						{
							$('#author_buttons button').prop('disabled', true);
						}
						else
						{
							$('#author_buttons button').prop('disabled', false);
						}
					}

					_this.process(res);
				}
				else
				{

				}

			}
		});		
	}

	createPerson(parent) {
		let _this = this;
		let data = $(parent).serialize();
		let block = $(parent);
		let type = block.find('#add-author-type').val();

		$.ajax({
			url: "/ajax.php?mid=107",
			type: "POST",
			data: data + '&action=createPerson&id=' + this.id,
			dataType: "json",
			success: function(res) {
				if (res.success)
				{
					$('#' + type + '-block .authors-added__container').html(res.html);
					if (res.count > 0)
					{
						$('#' + type + '-block').slideDown();
					}
					else
					{
						$('#' + type + '-block').hide();
					}

					if (type == 'authors')
					{
						if (res.count >= 3)
						{
							$('#author_buttons button').prop('disabled', true);
						}
						else
						{
							$('#author_buttons button').prop('disabled', false);
						}
					}

					block.find('.psy-app__step-mistakes p').text('');
					block.find('.psy-app__step-mistakes').hide();

					parent.reset();
					_this.delPhoto($(parent).find('.author-new__photo-delete'));

					let popup = $(parent).closest('.popup-new-author');
					popup.removeClass('active');
					$('body').removeClass('no-scroll');
					this.process(res);
				}
				else
				{
					block.find('.psy-app__step-mistakes p').text('Возникла ошибка: ' + res.error);
					block.find('.psy-app__step-mistakes').fadeIn();
				}
			}
		});
	}

	showError(parent, text) {
		let el = $(parent).closest('.psy-app__item-content').find('.psy-app__item-mistake');
		el.text(text);
		el.fadeIn();
	}

	hideError(parent, allstep = 0) {
		let el;
		if (allstep)
			el = $(parent).closest('.psy-app__step').find('.psy-app__item-mistake');
		else
			el = $(parent).closest('.psy-app__group-content').find('.psy-app__item-mistake');
		el.text('');
		el.hide();
	}

	submit() {
		$.ajax({
			url: "/ajax.php?mid=107",
			type: "POST",
			data: {action: 'submit', id: this.id},
			dataType: "json",
			success: function(res) {
				if (res.success)
				{
					let url = location.pathname + location.search + '&done=1';
					location.href = url;
				}
				else
				{

				}
			}
		});
	}

	pay() {
		let url = location.pathname + location.search + '&pay=1';
		location.href = url;
	}

	control(c) {
		if (c)
		{
			let el;
			let action;
			console.log(c);
			for (let i = 0; i < c.length; i++)
			{
				el = $('#' + c[i].id);
				action = c[i].action;
				if (el.length)
				{
					if (action == 'enable')
						el.prop('disabled', false);
					if (action == 'disable')
						el.prop('disabled', true);
				}
			}
		}
	}

	delProject(parent, id) {
		if (confirm('Вы уверены, что хотите удалить проект? Отменить это действие невозможно.'))
		{
			let item = $(parent).closest('.apps-table__item');
			item.slideUp();
			$.ajax({
				url: "/ajax.php?mid=107",
				type: "POST",
				data: {action: 'delProject', id: id},
				dataType: "json",
				success: function(res) {
					if (res.success)
					{
						item.remove();
					}
					else
					{
						item.show();
					}
				}
			});
		}
	}
}